import React from "react";
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
//import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Settings } from "@mui/icons-material";
//import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
//import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
//import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import UpgradeOutlinedIcon from '@mui/icons-material/UpgradeOutlined';
import { styled } from '@mui/system';

import DashboardTemplate from "../components/templates/DashboardTemplate";
import MixpanelOnload from "../components/MixpanelOnload";
import MixpanelIconButton from "../components/MixpanelIconButton";
//import GA from '../utils/GoogleAnalytics';


const DashboardButton = styled(MixpanelIconButton)(({ theme }) => ({
    width: '250px',
    height: '100px',
    padding: '10px',
    margin: '10px',
    display: 'flex',
    borderRadius: '10px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    '& .MuiSvgIcon-root': {
        fontSize: '32px',
    },
    '& .MuiTypography-subtitle1': {
        fontSize: '20px',
        fontWeight: 'bold',
        lineHeight: 1.2,
    },
    '& .MuiTypography-caption': {
        fontSize: '15px',
        color: theme.palette.text.secondary,
        lineHeight: 1.2,
    },
}));


const DashboardContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
}));

class Dashboard extends React.Component {

    constructor() {
        super();
        this.state = {
            stripe: null,
            planType: "",
            productId: "",
            productName: "",
            unitCount: "",
            isOldPlan: false,
            isTrial: true,
            trialEndDate: '',
            featureDm: false
        };
    }

    // no plan -> urges to select plan
    // no payment -> urges to set payment (+14 days from registration)
    // under trial -> shows period
    // under free plan -> shows character count limit
    render() {
        const { featureDm } = this.state;
        return (
            <DashboardTemplate>
                <Typography variant="h5" component="h2" fontWeight="bold" margin="2">
                    Dashboard
                </Typography>

                <Paper elevation={0}>
                    <br />
                    {0 ?
                        <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_change-plan" size="large" aria-label="Change Plan" href="/change-plan">
                            <Box display="flex" alignItems="center" width="100%" height="100%">
                                <Box flex="0 0 auto" mr={2}>
                                    <PeopleAltOutlinedIcon fontSize="large" />
                                </Box>
                                <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                    <Typography variant="subtitle1">Plan</Typography>
                                    <Typography variant="caption">Change plan</Typography>
                                </Box>
                            </Box>
                        </DashboardButton>
                        : <div></div>
                    }
                    <DashboardContainer>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_change-plan" size="large" aria-label="Change Plan" href="/change-plan">
                                    <Box display="flex" alignItems="center" width="100%" height="100%">
                                        <Box flex="0 0 auto" mr={2}>
                                            <PeopleAltOutlinedIcon fontSize="large" />
                                        </Box>
                                        <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                            <Typography variant="subtitle1">Plan</Typography>
                                            <Typography variant="caption">Change plan</Typography>
                                        </Box>
                                    </Box>
                                </DashboardButton>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_change-payment" size="large" aria-label="Change Payment" href="/change-payment">
                                    <Box display="flex" alignItems="center" width="100%" height="100%">
                                        <Box flex="0 0 auto" mr={2}>
                                            <CreditCardOutlinedIcon fontSize="large" />
                                        </Box>
                                        <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                            <Typography variant="subtitle1">Payment</Typography>
                                            <Typography variant="caption">Update credit card info</Typography>
                                        </Box>
                                    </Box>
                                </DashboardButton>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_billing-history" size="large" aria-label="Billing history" href="/billing-history">
                                    <Box display="flex" alignItems="center" width="100%" height="100%">
                                        <Box flex="0 0 auto" mr={2}>
                                            <ReceiptOutlinedIcon fontSize="large" />
                                        </Box>
                                        <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                            <Typography variant="subtitle1">Billing</Typography>
                                            <Typography variant="caption">Check billing history</Typography>
                                        </Box>
                                    </Box>
                                </DashboardButton>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_account" size="large" aria-label="Account" href="/account">
                                    <Box display="flex" alignItems="center" width="100%" height="100%">
                                        <Box flex="0 0 auto" mr={2}>
                                            <Settings fontSize="large" />
                                        </Box>
                                        <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                            <Typography variant="subtitle1">Account</Typography>
                                            <Typography variant="caption">Check account info</Typography>
                                        </Box>
                                    </Box>
                                </DashboardButton>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_cancel" size="large" aria-label="Cancel" href="https://www.getkiara.com/contact">
                                    <Box display="flex" alignItems="center" width="100%" height="100%">
                                        <Box flex="0 0 auto" mr={2}>
                                            <CancelOutlinedIcon fontSize="large" />
                                        </Box>
                                        <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                            <Typography variant="subtitle1">Cancel</Typography>
                                            <Typography variant="caption">Cancenlattion procedure</Typography>
                                        </Box>
                                    </Box>
                                </DashboardButton>
                            </Grid>
                            {(!featureDm) ?
                                <Grid item xs={12} sm={6} md={4}>
                                    <DashboardButton mixpanelMessage="kiara_app_com_header_dashboard_upgrade" size="large" aria-label="Upgrade feature" href="/api/slack/upgrade">
                                        <Box display="flex" alignItems="center" width="100%" height="100%">
                                            <Box flex="0 0 auto" mr={2}>
                                                <UpgradeOutlinedIcon fontSize="large" />
                                            </Box>
                                            <Box flex="1 1 auto" display="flex" flexDirection="column" justifyContent="center">
                                                <Typography variant="subtitle1">Upgrade features</Typography>
                                                <Typography variant="caption">Check upgrade features</Typography>
                                            </Box>
                                        </Box>
                                    </DashboardButton>
                                </Grid>
                                : <div></div>
                            }
                        </Grid>
                    </DashboardContainer>
                </Paper>
                <MixpanelOnload message="kiara-app.com/dashboard" />
            </DashboardTemplate>
        )
    }
}

export default Dashboard;